import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=deffa2e2&"
import script from "./Top.vue?vue&type=script&lang=ts&"
export * from "./Top.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseIcon: require('/app/components/base/Icon.vue').default,BaseButton: require('/app/components/base/Button.vue').default,BlocksFooterAlleFolders: require('/app/components/blocks/FooterAlleFolders.vue').default,BlocksNewsletter: require('/app/components/blocks/Newsletter.vue').default})
